module.exports = __webpack_public_path__ + "img/start_btn_2021.3875d406.png";